/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ImportSageIntacctCustomersInput = {|
  sageIntacctCustomerIds?: ?$ReadOnlyArray<?string>,
  companyId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ImportSageIntacctCustomersMutationVariables = {|
  input: ImportSageIntacctCustomersInput
|};
export type ImportSageIntacctCustomersMutationResponse = {|
  +importSageIntacctCustomers: ?{|
    +clients: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +notes: ?string,
        +logoId: ?string,
        +logoDefaultId: ?number,
        +projectCount: ?number,
        +economicCustomerId: ?string,
        +quickbooksCustomerId: ?string,
        +xeroContactId: ?string,
        +salesforceAccountId: ?string,
        +hubspotCompanyId: ?string,
        +pipedriveOrganizationId: ?string,
        +sageIntacctCustomerId: ?string,
      |}
    |}>
  |}
|};
export type ImportSageIntacctCustomersMutation = {|
  variables: ImportSageIntacctCustomersMutationVariables,
  response: ImportSageIntacctCustomersMutationResponse,
|};
*/


/*
mutation ImportSageIntacctCustomersMutation(
  $input: ImportSageIntacctCustomersInput!
) {
  importSageIntacctCustomers(input: $input) {
    clients {
      node {
        id
        name
        notes
        logoId
        logoDefaultId
        projectCount
        economicCustomerId
        quickbooksCustomerId
        xeroContactId
        salesforceAccountId
        hubspotCompanyId
        pipedriveOrganizationId
        sageIntacctCustomerId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportSageIntacctCustomersInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctCustomersPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctCustomers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroContactId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveOrganizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctCustomerId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctCustomersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctCustomersMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctCustomersMutation(\n  $input: ImportSageIntacctCustomersInput!\n) {\n  importSageIntacctCustomers(input: $input) {\n    clients {\n      node {\n        id\n        name\n        notes\n        logoId\n        logoDefaultId\n        projectCount\n        economicCustomerId\n        quickbooksCustomerId\n        xeroContactId\n        salesforceAccountId\n        hubspotCompanyId\n        pipedriveOrganizationId\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f7dd249af9ee6aa611df29c43619138';

module.exports = node;
